export function isStorybookEnvironment(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window.location.href.includes('viewMode=story') ||
      window.location.href.includes('iframe.html') ||
      window.location.href.toLowerCase().includes('storybook') ||
      !!(window as any).__STORYBOOK_CLIENT_API__ ||
      !!(window as any).STORYBOOK_PREVIEW ||
      !!(window as any).__FORCE_STORYBOOK_MODE)
  );
}
